import React from 'react';
import unitedStates from 'united-states';
import {Section, Table, NameCell, ValueCell, InputCell} from '../components/cells';
import {money, count} from '../model/format';

const STATE_OPTIONS = unitedStates
    .filter(state => !state.isTerritory)
    .map(state => ({value: state.abbr, label: state.name}));

/**
 * Property Information sheet. Name, address, city, state, ZIP and year built are saved to
 * the property record as well; Total Units and Rentable SF come from the Current Rent Roll.
 */
export default function PropertyInformation({inputs, calc, setField}) {
    const input = (key, props = {}) => <InputCell value={inputs[key]} onChange={value => setField(key, value)} {...props}/>;
    const row = (label, cell) => <tr key={label}><NameCell>{label}</NameCell>{cell}</tr>;
    const info = calc.propertyInfo;

    return (
        <div className='mf-tab mf-property-information'>
            <div className='Financials_list_columns'>
                <div className='Financials_list_column mf-column'>
                    <Section title='Property Information'>
                        <Table className='mf-kv-table mf-wide-values'>
                            {row('Property Name', input('name', {kind: 'text'}))}
                            {row('Address', input('address', {kind: 'text'}))}
                            {row('City', input('city', {kind: 'text'}))}
                            {row('State', input('state', {kind: 'select', options: STATE_OPTIONS}))}
                            {row('ZIP', input('zip', {kind: 'text'}))}
                            {row('County', input('county', {kind: 'text'}))}
                            {row('Year Built/Renovated', input('year_built', {kind: 'text'}))}
                            {row('Lot Size (acres)', input('lot_size', {unit: 'Acres', decimals: 2}))}
                            {row('Parking Spaces', input('parking_spaces'))}
                            {row('Total Units', <ValueCell>{count(info.total_units)}</ValueCell>)}
                            {row('Rentable SF', <ValueCell>{count(info.rentable_sf)}</ValueCell>)}
                            {row('Parking (spaces per unit)', <ValueCell>{info.parking_per_unit ? info.parking_per_unit.toFixed(2) : '-'}</ValueCell>)}
                        </Table>
                    </Section>
                </div>
                <div className='Financials_list_column mf-column'>
                    <Section title='Taxes'>
                        <Table className='mf-kv-table'>
                            {row('Current Tax Appraised Value', input('current_tax_appraised_value', {unit: '$'}))}
                            {row('Mill Rate (tax rate)', input('mill_rate', {unit: '%', decimals: 4}))}
                            {row('Current Tax Liability', <ValueCell>{money(info.current_tax_liability)}</ValueCell>)}
                            {row('New Assessed Value', input('new_assessed_value', {unit: '$'}))}
                            {row('New Taxes', <ValueCell>{money(info.new_taxes)}</ValueCell>)}
                        </Table>
                    </Section>
                    <Section title='Links'>
                        <Table className='mf-kv-table mf-links-table'>
                            {row('Google Maps Link', input('google_maps_link', {kind: 'link'}))}
                            {row('CAD Link', input('cad_link', {kind: 'link'}))}
                        </Table>
                    </Section>
                </div>
            </div>
        </div>
    );
}
